module.exports = __webpack_public_path__ + "img/short-link-logo-with-name.f518e995.png";